import React, { useState } from 'react'
import { Navigate } from "react-router";
import { useNavigate } from 'react-router-dom';


import { login } from '../api/users'

import { Button, TextField, Box } from '@mui/material'

import { PAGE_AFTER_LOGIN } from '../scripts/configData'

export default function LoginPage() {

  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')

  const navigate = useNavigate();

  if (localStorage.getItem('token')) {
    navigate(PAGE_AFTER_LOGIN);
  }


  const userLogin = async () => {
    if (await login(user, password)) {
      navigate(PAGE_AFTER_LOGIN);
    }

  }


  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', height: '70vh', placeItems: 'center' }}>

      <Box sx={{ display: 'inline-grid', gap: 3 }}>

        <TextField
          value={user}
          onChange={e => setUser(e.target.value)}
          id="outlined-basic"
          label="Login"
          variant="outlined"
          slotProps={{ inputLabel: { shrink: true } }}

        />

        <TextField
          value={password}
          onChange={e => setPassword(e.target.value)}
          id="outlined-password-input"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant='outlined'
          slotProps={{ inputLabel: { shrink: true } }}
        />

        <Button sx={{}} variant='contained' onClick={() => userLogin()}>Login</Button>

      </Box>
    </Box>
  )
}
